// =============================================================================
// app/src/lib/mapa.ts — casamento entre o código de localização e as zonas.
//
// Localização da peça segue o padrão D7: corredor-prateleira-gaveta (A-P3-G2).
// As zonas do mapa têm códigos em níveis: 'A' (corredor) ou 'A-P3' (prateleira).
// A zona certa é a de PREFIXO MAIS LONGO que casa com a localização — se o
// mapa tem 'A' e 'A-P3', a peça em A-P3-G2 acende 'A-P3'; se só tem 'A',
// acende o corredor inteiro. Mapa em qualquer nível de detalhe funciona.
// =============================================================================
import type { StoreZone } from '@core/types';

const norm = (s: string) => s.toUpperCase().replace(/\s/g, '');

/** true se `zona` é prefixo de `local` respeitando o separador de nível. */
export const zonaCasaComLocal = (codigoZona: string, local: string): boolean => {
  const z = norm(codigoZona);
  const l = norm(local);
  if (!z || !l) return false;
  return l === z || l.startsWith(z + '-');
};

/** A zona de prefixo mais longo que casa com a localização (ou null). */
export const zonaDaPeca = (zonas: StoreZone[], local: string | null): StoreZone | null => {
  if (!local) return null;
  let melhor: StoreZone | null = null;
  for (const z of zonas) {
    if (z.tipo === 'parede' || z.tipo === 'porta') continue;   // estrutura não "contém" peça
    if (!zonaCasaComLocal(z.codigo, local)) continue;
    if (!melhor || z.codigo.length > melhor.codigo.length) melhor = z;
  }
  return melhor;
};

/** Retângulo envolvente de todas as zonas, com margem — vira o viewBox do SVG. */
export const limitesDoMapa = (zonas: StoreZone[], margem = 20) => {
  if (zonas.length === 0) return null;
  const minX = Math.min(...zonas.map((z) => Number(z.x_cm)));
  const minY = Math.min(...zonas.map((z) => Number(z.y_cm)));
  const maxX = Math.max(...zonas.map((z) => Number(z.x_cm) + Number(z.largura_cm)));
  const maxY = Math.max(...zonas.map((z) => Number(z.y_cm) + Number(z.altura_cm)));
  return {
    x: minX - margem,
    y: minY - margem,
    largura: maxX - minX + margem * 2,
    altura: maxY - minY + margem * 2,
  };
};
